import Button from "@mui/material/Button";
import React from "react";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

export const InTownURI = "/where-to-dance/in-near-town"
export const InTownButton = (props) => <Button {...props} size={"small"} startIcon={<CalendarMonthIcon size={"small"} />} href={InTownURI}><span style={{fontSize: "80%"}}>In Town</span></Button>